import React, { Component } from 'react'
import { object } from 'prop-types'

import Logo from 'assets/img/bisu-logo-md.png'

class Header extends Component {
  render() {
    const { header } = this.props
    return (
      <table className="curriculum-head">
        <tbody>
          <tr>
            <td width="70">
              <img src={Logo} width="70" alt="BISU LOGO" className="logo" />
            </td>
            <td>
              Republic of the Philippines<br/>
              <strong>BOHOL ISLAND STATE UNIVERSITY</strong><br />
              <em>Main Campus</em><br />
              CPG. Avenue, Tagbilaran City, Bohol, Philippines
            </td>
            <td width="200" className="text-right vbottom">
              <strong>Office of the Registrar</strong><br />
              <small><em>registrar.main@bisu.edu.ph</em></small><br />
              <small><em>RO DOC 3</em></small>
            </td>
          </tr>
          <tr>
            <td className="text-center" colSpan="3">
              <div className="title">{header.get('name')}</div>
              <small>CURRICULUM SUBJECTS</small>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
}

Header.propTypes = {
  header: object,
}

export default Header



// WEBPACK FOOTER //
// ./src/containers/Print/Curriculums/header.js